module.exports = __webpack_public_path__ + "static/media/mBank-Bold.df3b7e72.woff2";